<template>
  <div class="insights-meetings-widget-dialog-time-of-day">
    <div class="title">Time of day</div>

    <InsightsMeetingsRecurring period="day" />
  </div>
</template>

<script>
import InsightsMeetingsRecurring from '~/components/insights/InsightsMeetingsRecurring.vue';

export default {
  name: 'InsightsMeetingsDialogTimeOfDay',
  components: {
    InsightsMeetingsRecurring,
  },
};
</script>
